import { faDownload, faFile } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar, Button, Card, CardActions, CardContent, CardHeader, Grid, LinearProgress, Link, Pagination, Typography } from "@mui/material";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ServiceContext } from "../../Contexts/ServiceContext/ServiceContext";
import { useLoading } from "../../Hooks/useLoading";
import { usePagination } from "../../Hooks/usePagination";
import { IDocumentRecord } from "../../Interfaces/IDocumentRecord";
import { GLOBALS } from "../../Models/Globals";
import { NoRecordsMessage } from "../NoRecordsMessage/NoRecordsMessage";



export const CardDocumentRender = ({ }) => {

    const { SrvContext } = useContext(ServiceContext);
    const { t, i18n } = useTranslation();
    const [isLoading, SetIsLoading] = useLoading();
    const [currentPage, OnPageChange, GetPageCount, GenPublishingDate] = usePagination();
    const itemsPerPage = GLOBALS.MIN_TO_RENDER_PAGINATION;

    const [currentDocs, setCurrentDocs] = useState<IDocumentRecord[]>([]);

    const Initialize = async () => {

        const docs = SrvContext.WindowData.sccoDocsRender.DocsToRender;
        setCurrentDocs(docs);
        await i18n.changeLanguage(SrvContext.WindowData.sccoDocsRender.idiomaCode);
        SetIsLoading(false);

    };


    useEffect(() => {

        Initialize();

    }, []);

    return (
        <Grid container spacing={3} xs={12}>
            {
                isLoading ? (
                    <LinearProgress />
                ) : (
                    <>
                        {
                            currentDocs.length == 0 ? (
                                <NoRecordsMessage />
                            ) : (
                                currentDocs.slice((currentPage - 1) * itemsPerPage, (currentPage - 1) * itemsPerPage + itemsPerPage).map((doc: IDocumentRecord, index: number) => (
                                    <Grid item xs={12} md={3} key={`document-item-${index}`}>
                                        <Card>
                                            <CardHeader
                                                avatar={
                                                    <Avatar sx={{ backgroundColor: "primary.main" }}>
                                                        <FontAwesomeIcon icon={faFile} />
                                                    </Avatar>
                                                }
                                                subheader={GenPublishingDate(doc.fecha_publicacion)}
                                            />
                                            <CardContent>
                                                <Typography variant="h6">
                                                    {t('label-description')}
                                                </Typography>
                                                <Typography variant="body1">
                                                    {doc.descripcion}
                                                </Typography>
                                            </CardContent>
                                            <CardActions sx={{ justifyContent: "right" }}>
                                                <Link target="_blank" href={`${doc.url}`}>
                                                    <Button variant="contained" color="primary">
                                                        <Typography variant="body1">
                                                            <FontAwesomeIcon icon={faDownload} /> {t('label-view-file')}
                                                        </Typography>
                                                    </Button>
                                                </Link>
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                ))
                            )
                        }
                        {
                            currentDocs.length > GLOBALS.MIN_TO_RENDER_PAGINATION &&
                            <Grid item xs={12}>
                                <Pagination count={GetPageCount(currentDocs.length)} page={currentPage} onChange={OnPageChange} />
                            </Grid>
                        }
                    </>
                )
            }
        </Grid >
    );

};